import React from 'react';

import { OptionProps, components } from 'react-select';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import classes from 'components/common/MyCustomSelect/components/InputOptionsWithIcon/InputOptionsWithIcon.module.scss';

export const InputOptionsWithIcon = <T,>(
    props: OptionProps<T> & {
        data: {
            label: string;
            icon?: string;
            muiIcon?: string;
        };
    },
) => {
    const { icon, muiIcon, label } = props.data;

    const iconElement = Boolean(icon || muiIcon) ? (
        icon ? (
            <Icon name={icon} size={'1.6rem'} color={'var(--text-primary)'} />
        ) : (
            <MuiIcon icon={muiIcon} />
        )
    ) : null;

    return (
        <components.Option {...props}>
            {iconElement ? (
                <div className={classes.labelWithIconWrapper}>
                    <div className={classes.iconWrapper}>{iconElement}</div>
                    {label}
                </div>
            ) : (
                label
            )}
        </components.Option>
    );
};
